import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { useIntersectionObserver, useLatest } from '@fiverr-private/hooks';
import { Loader } from '@fiverr-private/fit';
import { grey_700 } from '@fiverr-private/sass/helpers';

import classes from './ShowMore.module.scss';

interface ShowMoreProps {
  isLoading: boolean;
  hasMore: boolean;
  loadMore: () => void;
}

export const ShowMore = ({ isLoading, hasMore, loadMore }: ShowMoreProps) => {
  const observableRef = useRef(null);
  const observableEntry = useIntersectionObserver(observableRef);
  const isIntersecting = observableEntry?.isIntersecting || false;

  const loadMoreRef = useLatest(loadMore);

  useEffect(() => {
    if (!isLoading && isIntersecting && hasMore) {
      loadMoreRef.current();
    }
  }, [loadMoreRef, isLoading, isIntersecting, hasMore]);

  const className = classnames(classes.container, 'flex flex-center');

  return (
    <div ref={observableRef} className={className}>
      {/* TS Error from Penta Loader: Property 'SIZES' does not exist on type 'typeof Loader' */}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-expect-error */}
      {isLoading && <Loader color={grey_700} size={Loader.SIZES.MD} />}
    </div>
  );
};
